
export enum SnapshotDataTypeCd {
	JSON = 'JSON',
	XML = 'XML'}

